.mvContainer {
    font-family: -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto,
        Helvetica Neue, Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;

    select {
        /* styling */
        background-color: white;
        border: thin solid #dfdfdf;
        border-radius: 999px;
        display: inline-block;
        width: 100%;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;

        /* reset */

        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;

        /* Extra styles */
        background-image: linear-gradient(45deg, transparent 50%, gray 50%),
            linear-gradient(135deg, gray 50%, transparent 50%),
            linear-gradient(to right, #ccc, #ccc);
        background-position: calc(100% - 20px) calc(1em + 2px),
            calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
        background-size: 5px 5px, 5px 5px, 1px 1.5em;
        background-repeat: no-repeat;
    }

    &,
    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    h1 {
        font-size: 2.25rem;
        color: #14456b;
    }

    h2 {
        font-size: 1.5rem;
        color: #14456b;
    }

    a {
        color: inherit;
        font-weight: 600;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    label {
        font-size: 0.875rem;
        font-weight: 600;
        margin-bottom: 0.3rem;
    }

    input {
        padding: 0.5rem;
        border: 1px solid #dfdfdf;
        border-radius: 5px;

        &:disabled {
            cursor: not-allowed;
        }
    }

    input[type="checkbox"] {
        /* Remove most all native input styles */
        appearance: none;
        /* For iOS < 15 */
        background-color: var(--form-background);
        /* Not removed via appearance */
        margin: 0;

        font: inherit;
        cursor: pointer;
        color: currentColor;
        width: 1.15em;
        height: 1.15em;
        border: 0.15em solid currentColor;
        border-radius: 0.15em;
        transform: translateY(-0.075em);

        display: grid;
        place-content: center;
    }

    input[type="checkbox"]::before {
        content: "";
        width: 0.65em;
        height: 0.65em;
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
        transform: scale(0);
        transform-origin: bottom left;
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em var(--form-control-color);
        /* Windows High Contrast Mode */
        background-color: CanvasText;
    }

    input[type="checkbox"]:checked {
        background-color: #14456b;
        border-color: #14456b;
        color: #fff;
    }

    input[type="checkbox"]:checked::before {
        transform: scale(1);
        background-color: #fff;
    }

    input[type="checkbox"]:disabled {
        --form-control-color: var(--form-control-disabled);
        color: var(--form-control-disabled);
        cursor: not-allowed;
    }

    .crosshair-cursor-enabled {
        cursor: crosshair !important;
    }
}

.mvContainerModal {
    @extend .mvContainer;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid rgb(204, 204, 204);
    background: rgb(255, 255, 255);
    overflow: hidden;
    border-radius: 4px;
    outline: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;

    @media screen and (min-width: 768px) {
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
        right: 40px;
        // bottom: auto;
        margin-bottom: 40px;
        max-width: 1140px;
    }
}
